import React, { Component } from 'react';
import SelectAziende from './SelectAziende';
import CreaMenu from './CreaMenu';
import CreaPacchetto from './CreaPacchetto';
import { BASE_URL } from './config';
import { leggiToken } from './services/sessione';
import CreaTradizioni from './CreaTradizioni';
import SelectTipologie from './SelectTipologia';
import './CreaEvento.css';

class CreaEvento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAziendaId: '',
      selectedCategoria: '',
      errori: [],            // esiti della validazione, prima della chiamata
      esito: null,           // { tipo: 'successo' | 'errore', testo }
      invioInCorso: false,
      formData: {
        titolo: '',
        descrizione: '',
        dataInizio: '',
        dataFine: '',
        campiMenu: [],
        categorie: [], // Stato per le categorie disponibili
        prezzo: 0,
        immagineCopertina: null
      }
    };
  }

  componentDidMount() {
    this.fetchCategorie();
  }

  /* La scelta dell'azienda e' interamente di SelectAziende, che notifica
   * handleSelectedAzienda: admin tramite autocompletamento, utente azienda
   * con la propria unica azienda. Qui resta solo il caricamento delle
   * tipologie, che sono le stesse per tutti e non dipendono dall'azienda. */

  fetchCategorie = () => {
    const headers = new Headers({
      'Authorization': 'Bearer ' + leggiToken(),
      'Content-Type': 'application/json'
    });

    
    fetch(`${BASE_URL}/eventi/tipologie`, { headers })
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          this.setState(prevState => ({
            formData: { ...prevState.formData, categorie: data }
          }));
        }
      })
      .catch(() => {});
  };

  handleSelectedAzienda = (azienda) => {
    // La tipologia dell'azienda non viene conservata: non vincola le tipologie
    // di evento creabili, che restano tutte disponibili per ogni azienda.
    this.setState({ selectedAziendaId: azienda.id, errori: [] });
  };

  handleSelectChange = (categoria, tipologia ) => {
    
    this.setState({ selectedCategoria: categoria.code, selectedTipologia: tipologia });
  };

  /* Controlli fatti prima di chiamare il backend.
   * L'azienda in particolare non e' facoltativa: se arriva nulla il backend
   * ripiega sull'azienda dell'utente collegato, e per un admin — che non ne ha
   * nessuna — fallisce con IndexOutOfBoundsException e un 500 opaco. */
  validaForm = (formData, idAzienda, tipologia) => {
    const errori = [];

    if (!idAzienda) {
      errori.push("Seleziona l'azienda per cui creare l'evento.");
    }
    if (!tipologia) {
      errori.push('Seleziona la tipologia di evento.');
    }
    if (!formData.titolo || !formData.titolo.trim()) {
      errori.push('Il titolo è obbligatorio.');
    }
    if (formData.dataInizio && formData.dataFine &&
        formData.dataFine < formData.dataInizio) {
      errori.push('La data di fine non può precedere quella di inizio.');
    }
    if (formData.prezzo !== undefined && formData.prezzo !== null &&
        Number(formData.prezzo) < 0) {
      errori.push('Il prezzo non può essere negativo.');
    }

    return errori;
  };

  handleSubmit = (formData) => {
    // idAzienda viene dallo state, non dalle props: e' il selettore azienda a
    // valorizzarlo, e per un admin la prop e' vuota.
    const { selectedTipologia, selectedAziendaId } = this.state;

    const errori = this.validaForm(formData, selectedAziendaId, selectedTipologia);
    if (errori.length > 0) {
      this.setState({ errori, esito: null });
      return;
    }

    const headers = new Headers({
      'Authorization': 'Bearer ' + leggiToken(),
      'Content-Type': 'application/json'
    });

    const finalFormData = {
      ...formData,
      tipologiaEvento: selectedTipologia,
      idAzienda: selectedAziendaId
    };

    this.setState({ errori: [], esito: null, invioInCorso: true });

    fetch(`${BASE_URL}/eventi`, {
      method: 'POST',
      headers,
      body: JSON.stringify(finalFormData)
    })
      .then(async response => {
        // response.json() da solo non basta: su 4xx/5xx il corpo viene comunque
        // interpretato e l'errore passerebbe inosservato.
        if (!response.ok) {
          throw new Error(await this.estraiMessaggioErrore(response));
        }
        return response.json().catch(() => ({}));
      })
      .then(() => {
        // Il form si svuota SOLO dopo un salvataggio andato a buon fine.
        this.setState(prevState => ({
          formData: {
            titolo: '',
            descrizione: '',
            dataInizio: '',
            dataFine: '',
            campiMenu: [],
            categorie: prevState.formData.categorie,
            prezzo: 0,
            immagineCopertina: null
          },
          selectedCategoria: '',
          invioInCorso: false,
          esito: { tipo: 'successo', testo: 'Evento creato correttamente.' }
        }));
      })
      .catch(errore => {
        this.setState({
          invioInCorso: false,
          esito: { tipo: 'errore', testo: errore.message }
        });
      });
  };

  /* Il backend risponde a volte con una stringa, a volte con {message: ...}.
   * Su 500 il messaggio tecnico non va mostrato all'utente. */
  estraiMessaggioErrore = async (response) => {
    if (response.status === 401 || response.status === 403) {
      return 'Non hai i permessi per creare questo evento, oppure la sessione è scaduta.';
    }

    let dettaglio = '';
    try {
      const testo = await response.text();
      try {
        const json = JSON.parse(testo);
        dettaglio = json.message || json.error || '';
      } catch (e) {
        dettaglio = testo;
      }
    } catch (e) {
      dettaglio = '';
    }

    if (response.status >= 500) {
      return 'Errore del server durante il salvataggio. Riprova; se persiste, segnalalo.';
    }

    return dettaglio
      ? `Salvataggio non riuscito: ${dettaglio}`
      : `Salvataggio non riuscito (codice ${response.status}).`;
  };

  render() {
    const { selectedCategoria, selectedAziendaId, formData } = this.state;

    let componenteForm = null;
  
    if (selectedCategoria === 'food') {
      componenteForm = <CreaMenu onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    } else if (selectedCategoria === 'tradition') {
      componenteForm = <CreaTradizioni onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    } else if (selectedCategoria === 'transport') {
      componenteForm = <CreaPacchetto onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    }
    else if (selectedCategoria === 'solemare') {
      componenteForm = <CreaPacchetto onFormSubmit={this.handleSubmit} azienda={selectedAziendaId} />;
    }
  
  

    const { errori, esito, invioInCorso } = this.state;

    return (
      <div className='main-content'>
        <div className='crea-evento'>

          <header className='crea-evento__intestazione'>
            <h1>Nuovo evento</h1>
            <p>Compila i tre passi per pubblicare un evento.</p>
          </header>

          <div className='crea-evento__passo'>
            <h2 className='crea-evento__titolo'>
              <span className='crea-evento__numero'>1</span>
              Azienda
            </h2>
            <SelectAziende
              onSelectedData={this.handleSelectedAzienda}
              idAziendaFissa={this.props.idAzienda}
            />
          </div>

          <div className='crea-evento__passo'>
            <h2 className='crea-evento__titolo'>
              <span className='crea-evento__numero'>2</span>
              Tipologia di evento
            </h2>
            <SelectTipologie data={formData.categorie} onChange={this.handleSelectChange} />
          </div>

          {errori.length > 0 && (
            <div className='avviso avviso--errore' role='alert'>
              <strong>Controlla questi campi:</strong>
              <ul className='avviso__elenco'>
                {errori.map((e, i) => <li key={i}>{e}</li>)}
              </ul>
            </div>
          )}

          {esito && (
            <div
              className={`avviso avviso--${esito.tipo === 'successo' ? 'successo' : 'errore'}`}
              role={esito.tipo === 'successo' ? 'status' : 'alert'}
            >
              {esito.testo}
            </div>
          )}

          <div className={`crea-evento__passo${componenteForm ? '' : ' crea-evento__passo--spento'}`}>
            <h2 className='crea-evento__titolo'>
              <span className='crea-evento__numero'>3</span>
              Dettagli
            </h2>
            {componenteForm ? (
              <div className={`form-evento${invioInCorso ? ' form-evento--invio' : ''}`}>
                {componenteForm}
              </div>
            ) : (
              <p className='crea-evento__suggerimento'>
                Scegli prima un'azienda e una tipologia: il modulo compare qui.
              </p>
            )}
          </div>

        </div>
      </div>
    );
  }
}

export default CreaEvento;
